export default class AText extends Phaser.GameObjects.BitmapText
{
    /**
     * CONFIG: {width, height}
     * @param {Phaser.Scene} scene 
     * @param {Phaser.GameObjects.Container} parent 
     * @param {object} config 
     */
    constructor(scene, x, y, text, defaultTextSize = 20, config = null, align = 1, font = 'Nasalization')
    {
        super(scene, x, y, font, text, defaultTextSize, align);

        this.config = config;
        this.defaultTextSize = defaultTextSize;

        this.setOrigin(.5);
        this.maxChars = -1;

        if(config != null) {
          this.fitText(this.text);
        }
    }

    setXPos(pos)
    {
        this.x += pos;
    }

    setTextTo(text)
    {
        if(this.config != null) this.fitText(text);
        else this.text = text;
    }

    fitText(text)
    {
        this.fontSize = this.defaultTextSize;
        this.wrap(text);

        if(this.config.height == null) return;

        while(this.height > this.config.height)
        {
            this.fontSize -= 1;
            this.wrap(text);
        }
    }

    wrap(text)
    {
        text = text.replace(/(\r\n|\n|\r)/gm, "");
        let words = text.split(' ');
        let curLineText = "";
        let lineIndex = 0;
        this.lines = [{length: 0, text: ""}];

        for(let i = 0; i < words.length; i++)
        {
            let word = ((i == 0) ? '' : ' ') + words[i];
            let wordWidth = this.getWidth(word);
            let lineWidth = this.getWidth(this.lines[lineIndex].text) + wordWidth;

            
            if(lineWidth >= this.config.width || word == "^" || word == " ^" || word == "^ " || word == " ^ ")
            {
                if( word == "^" || word == " ^" || word == "^ " || word == " ^ "){
                    word = "";
                }

                word = word.substr(1);

                this.lines.push({length: wordWidth, text: word});
                lineIndex++;
            }
            else
            {
                
                this.lines[lineIndex].length = lineWidth;
                this.lines[lineIndex].text += word;
            }
        }

        this.text = "";
        for(let i = 0; i < this.lines.length; i++)
        {
            this.text += ((i == 0) ? '' : '\n') + this.lines[i].text;
        }
    }

    getWidth(string)
    {
        let sizePercentage = this.fontSize/72;
        let stringWidth = 0;
        for (let i = 0; i < string.length; i++) 
        {
            let charData = this.fontData.chars[string.charCodeAt(i)];
            if (!charData) continue;
            let charWidth = charData.xAdvance ? charData.xAdvance : charData.width;
            stringWidth += (charWidth * sizePercentage);
        }
        return stringWidth;
    }
}